/**
 * @file Data visualization palettes for ApexCharts and custom visualizations.
 * These are consumed in JS chart configs (color math, SVG attrs) so they stay
 * literal hex — pick `dataViz` vs `dataVizDark` via `useThemeColors()`/mode.
 */

export const dataViz = {
  categorical: [
    '#f05776', // coral
    '#2A9D8F', // teal
    '#D4B96A', // warm gold
    '#4A5568', // slate
    '#7E8DB0', // muted blue
    '#C97B63', // terracotta
    '#8FB996', // sage
    '#B5838D' // dusty rose
  ],
  sequential: {
    coral: ['#FFD6DE', '#FF8FA3', '#f05776', '#D94468', '#8B1A35'],
    teal: ['#C0EDE8', '#66CFC3', '#2A9D8F', '#1F8478', '#0D4F48']
  },
  diverging: ['#8B1A35', '#D94468', '#f05776', '#FFB3C1', '#FAFAF8', '#94DED5', '#2A9D8F', '#166B62', '#0D4F48'],
  gridLine: 'rgba(30,41,59,0.08)',
  axisLabel: '#6B7A91',
  tooltip: {
    bg: '#F4F2EC',
    border: '#E4E0D6',
    text: '#111827'
  }
};

// Categorical hues lifted ~12–18 L at constant hue so lines/dots clear ~4.5:1
// on the dark base. Sequential ramps reverse (lightness encodes magnitude
// toward the reader on dark); diverging midpoint goes warm-neutral.
export const dataVizDark = {
  categorical: [
    '#F7708A', // coral (coral[4])
    '#42BFB0', // teal (teal[4])
    '#E3C87E', // warm gold
    '#8E98AB', // slate (charcoal[3])
    '#9DA9C6', // muted blue
    '#DD9B82', // terracotta
    '#A3CBAA', // sage
    '#CFA0AA' // dusty rose
  ],
  sequential: {
    coral: ['#8B1A35', '#D94468', '#f05776', '#FF8FA3', '#FFD6DE'],
    teal: ['#0D4F48', '#1F8478', '#2A9D8F', '#66CFC3', '#C0EDE8']
  },
  diverging: ['#FFB3C1', '#FF8FA3', '#F7708A', '#F36378', '#3F3A33', '#33AE9F', '#42BFB0', '#66CFC3', '#94DED5'],
  gridLine: 'rgba(250,245,235,0.08)',
  axisLabel: '#948D82',
  tooltip: {
    bg: '#2A261F',
    border: 'rgba(250,245,235,0.12)',
    text: '#FAFAF8'
  }
};
